import * as R from 'ramda';
import C from './constants';

const parseLabelAndId = (str) => {
  if (!str) return [null, null];
  const parts = str.split('#').filter((p) => p !== '');
  return [parts[0] || null, parts[1] || null];
};

const isFullyHighlighted = (str) => {
  if (!str) return false;
  const trimmed = str.trim();
  return /^<mark>[\s\S]*<\/mark>$/.test(trimmed);
};

const hasMarkTag = R.test(/<(\/)?mark>/);

const switchHighlight = (str) => {
  const [label, id] = parseLabelAndId(str);
  if (isFullyHighlighted(id)) {
    if (hasMarkTag(label)) return `${label}#${id}#`;
    return `<mark>${label}</mark>#${id}#`;
  }
  return str;
};

const parseId = (hl) => {
  const m = R.match(C.VALUE_MASK, hl);
  if (!R.isEmpty(m)) return R.pipe(R.nth(1), R.replace(/<\/?mark>/g, ''))(m);
  const fallback = R.match(/<mark>(.*?)<\/mark>/, hl);
  if (!R.isEmpty(fallback)) return R.nth(1, fallback);
  return null;
};

export default (hl) => {
  if (!hasMarkTag(hl)) return null;

  const split = R.split(C.FACET_LEVEL_SEPARATOR, hl);

  return {
    valueId: parseId(R.last(split)),
    label: R.pipe(
      R.map(switchHighlight),
      R.when(R.pipe(R.length, R.lt(1)), R.tail),
      R.join(C.FACET_HIGHLIGHT_SEPARATOR),
      R.replace(C.FACET_VALUE_MASK, ''),
    )(split),
  };
};
